import { Store } from '@/core/store/core.store';
import { _AUTH_STORE } from '../enums/auth.enum';
import { LoginParams } from '../params/auth.params';

export class AuthStoreFacade {

  get user() {
    return Store.state.AuthStore.user;
  }

  get hasSession() {
    return Store.state.AuthStore.hasSession;
  }

  get isPublisher() {
    return Store.getters['AuthStore/isPublisher'];
  }

  get isStudent() {
    return Store.getters['AuthStore/isStudent'];
  }

  async login(data: LoginParams) {
    await Store.dispatch(_AUTH_STORE.LOGIN, data);
    await this.getUserLogged();
  }

  getUserLogged() {
    return Store.dispatch(_AUTH_STORE.GET_USER_LOGGED);
  }

  setSession() {
    return Store.commit(_AUTH_STORE.SET_SESSION);
  }

  cleanSession() {
    return Store.commit(_AUTH_STORE.CLEAN_SESSION);
  }
}